// extracted by mini-css-extract-plugin
module.exports = {"photo":"member-list_photo__2Yr7_","name":"member-list_name__JjNn9","email":"member-list_email__sJeaa","you":"member-list_you__1fTQM","cost":"member-list_cost__2a1YR"};